import HomePayment from './HomePayment';

export default HomePayment;
